<div [ngSwitch]="getType()">
  <div *ngSwitchCase="enumFieldTypeAndPlaceHolder.INPUT">
    <div *ngIf="!shouldApplyOnlyNumbers">
    <input class="form-control mt-1 f-13" [ngClass]="{ 
      'map-highlighted-row': params?.data?.companyName === errorselectlist && params?.data?.correctField === '' && !submitted
    }" [(ngModel)]="value" [placeholder]="'Enter '+placevalue" (ngModelChange)="valueChange($event)"/>
  </div>
  <div *ngIf="shouldApplyOnlyNumbers">
    <input class="form-control mt-1 f-13" onlyNumbers
    [attr.maxlength]="getMaxLength()" 
          [ngClass]="{ 
      'map-highlighted-row': params?.data?.companyName === errorselectlist && params?.data?.correctField === '' && !submitted
    }" [(ngModel)]="value" [placeholder]="'Enter '+placevalue" (ngModelChange)="valueChange($event)"
    (focus)="checkIfSicCode()" />
  </div>

</div>
  <div *ngSwitchDefault>
    <div class="select-wrapper">
      <select [ngClass]="{
      'map-highlighted-row': params?.data?.companyName === errorselectlist && params?.data?.correctField === '' && !submitted
    }" [ngClass]="{
      'highlighted-row': (
        (params?.data?.requiredField?.includes(this.params?.data?.systemColumn) && params?.data?.mappedColumn.trim() === '') ||
        (params?.data?.isRequired && params?.data?.mappedColumn.trim() === '') ||
        (params?.data?.systemColumn === 'Company' && params?.data?.mappedColumn.trim() === '') ||
        (params?.data?.systemColumn === 'Stage' && params?.data?.mappedColumn.trim() === '') ||
        (params?.data?.systemColumn === 'Type' && params?.data?.mappedColumn.trim() === '') ||
        (params?.data?.systemColumn === 'Country' && params?.data?.mappedColumn.trim() === '') ||
        (routeUrl != routePath.CODECROSSWALK_ROUTEPATH && routeUrl != routePath.IMPORTCOMPANY_ROUTEPATH && params?.data?.systemColumn === 'SIC Code' && params?.data?.mappedColumn.trim() === '') ||
        (routeUrl != routePath.IMPORTCOMPANY_ROUTEPATH && params?.data?.systemColumn === 'SIC Description' && params?.data?.mappedColumn.trim() === '') ||
        (routeUrl != routePath.IMPORTCOMPANY_ROUTEPATH && params?.data?.systemColumn === 'NAICS Code' && params?.data?.mappedColumn.trim() === '') ||
        (routeUrl != routePath.IMPORTCOMPANY_ROUTEPATH && params?.data?.systemColumn === 'NAICS Year' && params?.data?.mappedColumn.trim() === '') ||
        (routeUrl != routePath.IMPORTCOMPANY_ROUTEPATH && params?.data?.systemColumn === 'NAICS Description' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'MPN' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'MFR' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Qty' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Date Code Year' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Date Code Week' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'RoHS' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Condition' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Testing' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Need Date' && params?.data?.mappedColumn.trim() === '')||
        (params?.data?.systemColumn === 'Opportunity Type' && params?.data?.mappedColumn.trim() === '')||
        (currentTab == tabName?.CODECROSSWALK_TAB ? (params?.data?.systemColumn === 'Industry' && params?.data?.mappedColumn.trim() === ''):'') ||
        (routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH?(params?.data?.systemColumn === 'Vendor Name' && params?.data?.mappedColumn.trim() === ''):'')
      ) && !submit
    }" #mySelect class="w-100 p-l-15 text-truncate p-r-25" [(ngModel)]="value"
        (ngModelChange)="valueChange($event)">
        <option value="">-Select {{placevalue}}</option>
        <option *ngFor="let item of selectlist" [value]="item "> {{ item }} </option>
      </select>
    </div>
  </div>
</div>


